(function ($, w, d, undefined) {
    'use strict';

    var Map = function (args) {
        var allLocations = [];
        var filteredLocations = [];
        var currentAction = null;
        var defaults = {
            data: [],
            isMobile: false,
            country: 'Australia', // Used as the default country to display.
            resultListChunks: 10,
            resultListSize: 10,
            toggleState: 'full',
            locations: {
                markers: [],
                length: 0
            },
            templates: {
                loadingTemplate: '<div class="google-map__info-window">Loading</div>',
                infoWindowTemplate: function(data) {
                    var html = '<div class="google-map__info-window">';
                        html += '<h3>'+data.ProviderName+'</h3>';
                    html += '<p>'+ data.fullAddress.join(', ') +'</p>';
                    html += '<span class="directions"><a href="https://maps.google.com?saddr=Current+Location&daddr='+data.Latitude+','+data.Longitude+'" target="_blank" data-ga="cta|click|Directions - '+data.fullAddress.join(', ')+' ">Get Directions <i class="icon icon-arrow-right"></i></a></span>';
                    html += '</div>';
                    return html;
                },
                listTemplate: function(data) {
                    var html = '';
                    
                    var currentState = '';
                    for(var i = 0; i < data.locations.length; i++) {
                        var location = data.locations[i];
                        if(location.State !== currentState) {
                            html += '<div class="state">'+location.State+'</div>';
                            currentState = location.State;
                        }

                        html += '<div class="item">';
                        html += '<h4><a class="store-name" href="#" data-store-lat="' + location.Latitude + '" data-store-lng="' + location.Longitude + '" data-store-id="' + location.Id + '">' + location.ProviderName + '</a></h4>';
                        html += '<p>' + location.fullAddress + '</p>';

                        if(typeof location.Phone !== 'undefined' && location.Phone !== null && location.Phone !== '') {
                            html += '<p class="phone"><i class="icon icon-call"></i> Phone: <a href="tel:' + location.Phone + '">' + location.Phone + '</a></p>';
                        }

                        if(typeof location.Fax !== 'undefined' && location.Fax !== null && location.Fax !== '') {
                            html += '<p class="fax"><i class="icon icon-print"></i> Fax: ' + location.Fax + '</p>';
                        }

                        if(typeof location.Email !== 'undefined' && location.Email !== null && location.Email !== '') {
                            html += '<p class="email"><i class="icon icon-mail"></i>  <a href="mailto:' + location.Email + '">' + location.Email + '</a></p>';
                        }

                        html += '<p class="directions"><a href="https://maps.google.com?saddr=Current+Location&daddr=' + location.Latitude + ',' + location.Longitude + '" target="_blank" data-ga="cta|click|Directions - ' + location.fullAddress.join(', ') + ' "><span class="text">Get Directions</span> <i class="icon icon-arrow-right"></i> </a></p>';
                        html += '</div>';
                    }
                    return html;
                },
                // listTemplate: _.template([
                //     '<% _.each(locations, function(location) { %>',
                //     '<% if (location.State !== currentstate) { %>',
                //     '<div class="state"><%= location.State %></div>',
                //     '<% currentstate = location.State %>',
                //     '<% } %>',
                //     '<div class="item">',
                //     '<h4><a class="store-name" href="#" data-store-lat="<%= location.Latitude %>" data-store-lng="<%= location.Longitude %>" data-store-id="<%= location.Id %>"><%= location.ProviderName %></a></h4>',
                //     '<p><%= location.fullAddress %></p>',
                //     '<% if (location.Phone) { %><p class="phone"><i class="icon icon-call"></i> Phone: <a href="tel:<%= location.Phone %>"><%= location.Phone %></a></p><% } %>',
                //     '<% if (location.Fax) { %><p class="fax"><i class="icon icon-print"></i> Fax: <%= location.Fax %></p><% } %>',
                //     '<% if (location.Email) { %><p class="email"><i class="icon icon-mail"></i>  <a href="mailto:<%= location.Email %>"><%= location.Email %></a></p><% } %>',
                //     '<p class="directions"><a href="https://maps.google.com?saddr=Current+Location&daddr=<%= location.Latitude %>,<%= location.Longitude %>" target="_blank" data-ga="cta|click|Directions - <%= location.fullAddress %> "><span class="text">Get Directions</span> <i class="icon icon-arrow-right"></i> </a></p>',
                //     '</div>',
                //     '<% }) %>'
                // ].join("\n")),
            },
            map: {
                apiKey: 'AIzaSyATo7PXvDg1crsATFEjzvvg4HjaF7NPmDI',
                view: {},
                geocoder: {},
                infoWindow: {},
                clusterManager: {},
                countryBounds: false,
                minZoom: $(window).width() < 768 ? 2 : 3,
                maxZoom: 13,
                placeID: 0,
                defaultMarkerImage: '/static/img/'+THF.SiteSettings.id+'/map/ui-googlemaps-pin.png',
                defaultCustomMarkerImage: '/static/img/'+THF.SiteSettings.id+'/map/ui-googlemaps-pin.svg',
                clusterIcons: [{
                    textColor: 'white',
                    url: '/static/img/common/map/cluster-icon.png',
                    height: 60,
                    width: 60
                }],
                settings: {
                    zoom: 5,
                    center: {},
                    disableDefaultUI: true,
                    zoomControl: true,
                    scrollwheel: false,
                    styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [{"color": "#444444"}]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [{"visibility": "off"}]
                        },
                        {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f7f7f7"}]},
                        {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"}]},
                        {
                            "featureType": "road",
                            "elementType": "all",
                            "stylers": [{"saturation": -100}, {"lightness": 45}]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "all",
                            "stylers": [{"visibility": "simplified"}]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.icon",
                            "stylers": [{"visibility": "off"}]
                        },
                        {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]},
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [{"color": "#e6e6e6"}, {"visibility": "on"}]
                        }
                    ]
                }
            },
            el: {
                wrap: '',
                map: '.map',
                mapSearchSection: '.map-search',
                findAddress: '.map-search__address-form',
                address: '.map-search__address',
                loading: '.google-map__loading',
                resultsList: '.location-results .map__results-list',
                results: '.location-results',
                toggle: '.maptoggle a',
                showMoreBtn: '.show-more',
                filter: '.filter select',
                mobileMenu: '.map-mobile-menu',
                storeName: '.store-name'
            }
        };
        var settings = $.extend(true, {}, defaults, args);

        function __construct() {
            // We only want to load the map api once.
            if (typeof w._gmapsReady === 'function') {
                // Loader for any subsequent calls.

                if (w.THF.Interface.MapReady) {
                    init();
                }
                else {
                    onMapReady();
                }
            }
            else {
                // First to load.
                w._gmapsReady = function () {
                    w.THF.Interface.MapReady = true;
                    init();
                };
                $.getScript('https://maps.google.com.au/maps/api/js?v=3.exp&key=' + settings.map.apiKey + '&callback=_gmapsReady&region=AU&language=en-au');
            }
        }

        var $wrap = $(settings.el.wrap);

        function el(selector) {
            return settings.el.wrap + ' ' + selector;
        }

        function $el(selector) {
            return $(selector, $wrap);
        }

        function onMapReady() {
            setTimeout(function () {
                if (!w.THF.Interface.MapReady) {
                    onMapReady();
                }
                else {
                    init();
                }
            }, 200);
        }

        function setupMap() {
            settings.map.geocoder = new google.maps.Geocoder();
            settings.map.infoWindow = new google.maps.InfoWindow();
            settings.map.settings.center = new google.maps.LatLng(-33.9, 151.2);
            settings.map.defaultMarker = {
                url: settings.map.defaultMarkerImage,
                size: new google.maps.Size(30, 40),
                scaledSize: new google.maps.Size(30, 35)
            };
            settings.map.defaultCustomMarker = {
                url: settings.map.defaultCustomMarkerImage,
                size: new google.maps.Size(24,32),
                scaledSize: new google.maps.Size(24, 32)
            };
            settings.map.view = new google.maps.Map($el(settings.el.map)[0], settings.map.settings);

            getLocations(function (response) {
                // Hide loading state
                $el(settings.el.loading).removeClass('is-visible');
                fitBoundsToMarkers();
            });

            initMapListeners();
        }

        function init() {
            settings.isMobile = isMobile();
            setupMap();

            $el(settings.el.resultsList).on('click', settings.el.storeName, function (e) {
                var lat = $(this).attr('data-store-lat');
                var lng = $(this).attr('data-store-lng');
                var storeID = $(this).attr('data-store-id');

                showLocation(lat, lng, storeID);
                $('html,body').animate({scrollTop: $el(settings.el.mapSearchSection).offset().top}, 300);
                e.preventDefault();
            });

            $el(settings.el.findAddress)
                .on('submit', onAddressSubmit)
                .on('focusin', '.is-invalid input', onAddressFocus);
            $el(settings.el.address).on('keyup', onAddressKeyup);

            $el(settings.el.toggle).on('click', toggle);
            $el(settings.el.filter).on('change', filterState);

            $(window).on('resize', resize);
            $(window).on('scroll', updateFixedMenu);
            $(settings.el.showMoreBtn).on('click', loadMore);

        }

        function onAddressFocus(e) {
            $(e.target).parent().removeClass('is-invalid');
        }

        /**
         * @function onAddressSearch
         * @param e (Event)
         * Reverse geocodes the address
         */
        function onAddressSubmit(e) {
            e.preventDefault();
            currentAction = 'address_submit';
            $el(settings.el.filter).val('ALL').change();

            var address = $el(settings.el.address).val();

            // IF ONLY ACCEPT POSTCODE
            // if (!address || isNaN(address) || address.toString().length !== 4) {
            //   $el(settings.el.address).parent().addClass('is-invalid');
            //   fitBoundsToMarkers();
            //   return;
            // }

            // ACCEPT ALL ENTRIES - IF NONE, RESET VIEW
            if (!address) {
                currentAction = null;
                return fitBoundsToMarkers();
            }

            // $el(settings.el.address).parent().removeClass('is-invalid');

            $el(settings.el.loading).addClass('is-visible');

            fitToAddress(address, function (results, status) {

                $el(settings.el.loading).removeClass('is-visible');

                if (status !== "OK") return;

                // Find the closest marker and center on it
                findClosestMarker(results[0].geometry.location.lat(), results[0].geometry.location.lng());

            }.bind(this));
            currentAction = null;
        }

        /**
         * @function onAddressKeyup
         * Key up even for the address field
         */
        function onAddressKeyup() {
            if ($el(settings.el.address).val()) $el(settings.el.address).removeClass('is-invalid');
        }

        function isMobile() {
            return $(w).width() < 768;
        }

        function calculateCenter() {
            settings.center = settings.map.view.getCenter();
        }

        function setLocations(data) {
            settings.data = data;
        }

        function getLocations(callback) {
            /**
             * @function getLocations
             * @param callback (Function)
             * Gets locations from the API
             */
            setLoadingState(true);

            if (typeof settings.data === 'string') {
                $.ajax({
                    type: "GET",
                    url: settings.data,
                    success: function (response) {
                        setLoadingState(false);
                        allLocations = response;
                        onLocationLoad(response);
                        if (typeof callback === 'function') {
                            callback.call(null, response);
                        }
                    },
                    error: function () {
                        // TODO
                        // console.log("Error loading map JSON");
                    }
                })
            }
            else {
                if (typeof callback === 'function') {
                    allLocations = settings.data;
                    onLocationLoad(allLocations);
                    callback.call(null, allLocations);
                }
            }
            setLoadingState(false);
        }

        /**
         * @function list
         * @param response (Object)
         */
        function loadList(response) {
            response = response || [];

            var locations = [], markup = '';

            _.each(response, function (location) {
                location.fullAddress = location.StreetAddress.split(",").concat(" " + location.Suburb + " " + location.Postcode);

                // Render the template
                location.template = settings.templates.infoWindowTemplate(location);

                var marker = _.chain(settings.locations.markers).find(function (marker) {
                    return marker.data.Id === location.Id;
                }).value();

                if (marker) {
                    _.extend(marker.data, location);
                    // Save the marker
                    locations.push(marker.data);
                }

            }, this);

            var marker = settings.map.infoWindow.anchor,
                zoomed = settings.map.view.getZoom() >= 9;

            // check if info window has a marker, and using loading template
            if (marker && settings.map.infoWindow.content === settings.templates.loadingTemplate) {
                showInfoWindow(marker.data.Id);
            }

            // Don't show results below a certain zoom level
            locations = _.sortBy(locations, 'State');

            // Set DOM data attributes
            $el(settings.el.results).attr('data-results', locations.length).attr('data-zoomed', zoomed);

            // Reduce the resultSet down to a manageable amount

            var locationsPage = locations.slice(0, settings.resultListSize);

            // Build the template
            markup = settings.templates.listTemplate({locations: locationsPage, currentstate: ''});
            $el(settings.el.resultsList).html(markup);


            loadMoreButtonState(locationsPage.length, locations.length);
        }

        function loadMoreButtonState(locationsPageLength, locationsLength) {
            if (locationsPageLength < locationsLength) {
                $el(settings.el.showMoreBtn).show();
            }
            else {
                $el(settings.el.showMoreBtn).hide();
            }
        }

        function resetListResults() {
            settings.resultListSize = 0;
            loadMore();
        }

        function loadMore() {
            onUpdateResults(settings.resultListSize + settings.resultListChunks);

            /*var newResults = settings.showing + 2;

             for (settings.showing; settings.showing < newResults; settings.showing++) {
             if (settings.showing >= $el(settings.el.resultsList).children().length - 1) {
             $el(settings.el.showMoreBtn).addClass('hide');
             }
             if ($el(settings.el.resultsList).children().eq(settings.showing).hasClass('state')) {
             newResults = newResults + 1;
             }
             $el(settings.el.resultsList).children().eq(settings.showing).attr('data-loaded', 'loaded');
             }

             updateFixedMenu();
             */
        }

        function setLoadingState(state) {
            var results = $el(settings.el.results);

            if (state === true) {
                results.addClass('loading');
            } else {
                results.removeClass('loading');
            }
        }

        function fitToAddress(address, callback) {

            // Set the map bounds to Australia
            settings.map.geocoder.geocode({
                address: address,
                componentRestrictions: {
                    country: settings.country
                }
            }, function (results, status) {

                // zoom out to country if no results found
                if (status !== "OK") {
                    return fitToAddress('Australia', callback);
                }

                if (results[0].address_components[0].short_name === settings.country) {
                    status = "DEFAULT";
                    settings.map.view.setZoom(5);
                }

                // Fit the map to the bounds
                if (_.isUndefined(results[0].place_id) || settings.map.placeID !== results[0].place_id) {
                    settings.map.placeID = results[0].place_id;
                }
                if (typeof callback === "function") callback.apply(this, arguments);

            }.bind(this));
        }

        function onLocationLoad(response) {
            // Update the UI
            buildMarkers({
                locations: response
            });

            // Get all existing groups (ie NSW, QLD, Overseas)
            var groups = [];
            _.each(response, function (location) {
                if ($.inArray(location.State, groups) === -1) groups.push(location.State);
            });

            // Create filter using existing groups
            _.each(groups, function (group) {
                $el(settings.el.filter).append('<option value="' + group + '">' + group + '</option>')
            });
            $el(settings.el.filter).selectpicker('refresh');
        }

        /**
         * @function initMapListeners
         * Initialises listeners on for Google Maps
         */
        function initMapListeners() {
            // Google Maps Events
            google.maps.event.addListener(settings.map.view, 'click', onMapClick);
            google.maps.event.addListener(settings.map.view, 'zoom_changed', onCheckZoom);
            google.maps.event.addListener(settings.map.view, 'idle', onUpdateResults);
            google.maps.event.addDomListener(window, 'resize', function () {
                settings.map.view.setCenter(settings.center);
            });
        }

        /**
         * @function buildMarkers
         * @param options (Object)
         * Loops through the model and creates markers
         */
        function buildMarkers(options) {
            // Remove all markers
            settings.locations.markers = [];

            // Using actual marker objects
            if (typeof options.markers !== "undefined") {
                settings.locations.markers = options.markers;
            }
            // Using locations from the API
            else if (typeof options.locations !== "undefined") {

                if (!options.locations.length) return;

                _.each(options.locations, function (location) {

                    // If there is a lat/long for this location
                    if (parseFloat(location.Latitude) && parseFloat(location.Longitude)) {

                        // Add the marker to the map
                        addMarker({
                            model: 'locations',
                            position: {
                                lat: parseFloat(location.Latitude),
                                lng: parseFloat(location.Longitude)
                            },
                            icon: settings.map.defaultCustomMarker,
                            data: location,
                            labelClass: "boomtown",
                            optimized: false
                        });
                    }

                }, this);
            }

            // Hide loading state
            $el(settings.el.loading).removeClass('is-visible');

            if (!settings.locations.markers.length) return;

            // Fit the map to the bounds of the markers
            // fn.fitBoundsToMarkers();

        }

        function addMarker(options) {
            /**
             * @function addMarker
             * Adds a marker to the googleMap
             */
            if (!options) return;

            var marker = new google.maps.Marker(_.extend({
                map: settings.map.view
            }, options));


            // Save the marker
            settings.locations.markers.push(marker);

            // Marker events
            google.maps.event.addListener(marker, 'click', onMarkerClick);

        }

        /**
         * @function markerClick
         * @param e (Event)
         * @param marker (Object)
         */
        function onMarkerClick(e, marker) {
            showInfoWindow(this);
        }

        /**
         * @function showInfoWindow
         * @param markerOrID (Object or Number)
         */
        function showInfoWindow(markerOrID) {
            console.log(markerOrID);
            var marker = _.isObject(markerOrID) ? markerOrID : _.find(settings.locations.markers, function (marker) {
                return marker.data.Id == markerOrID;
            });

            // var id = marker.data.Id;

            if (settings.map.view.getZoom() < settings.map.maxZoom) {
                settings.map.view.setZoom(settings.map.maxZoom);
            }

            settings.map.view.setCenter(marker.getPosition());

            // Close the info window
            settings.map.infoWindow.close();

            var markup = marker.data.template || settings.templates.loadingTemplate;

            settings.map.infoWindow.setContent(markup);
            settings.map.infoWindow.open(settings.map.view, marker);
        }

        function fitBoundsToMarkers() {
            /**
             * @function fitBoundsToMarkers
             * Resizes the bounds to fit all visible markers
             */
            var bounds = new google.maps.LatLngBounds();

            // Loop through all markers
            _.each(settings.locations.markers, function (marker) {
                // Extend the bounds to the markers bounds
                if (marker.getVisible()) bounds.extend(marker.getPosition());
            });

            // Fit the map to the bounds
            settings.map.view.fitBounds(bounds);

            // Don't zoom in too far
            var zoom = settings.map.view.getZoom();
            settings.map.view.setZoom(zoom > settings.map.maxZoom ? settings.map.maxZoom : zoom);
        }

        function findClosestMarker(lat, lng) {
            /**
             * @function findClosestMarker
             * @param lat (Number)
             * @param lng (Number)
             * Finds the closest marker to lat lng
             */
            var distance = false,
                closest = -1;

            _.each(settings.locations.markers, function (marker, i) {

                var dlat = Math.abs(marker.position.lat() - lat),
                    dlng = Math.abs(marker.position.lng() - lng),
                    d = Math.sqrt(Math.pow(dlat, 2) + Math.pow(dlng, 2));

                if (distance && d >= distance) return;

                distance = d;
                closest = i;

            }, this);

            // Set the map center to the closest marker
            var closestMarker = settings.locations.markers[closest],
                bounds = new google.maps.LatLngBounds(),
                location = new google.maps.LatLng(lat, lng);

            bounds.extend(location);
            bounds.extend(closestMarker.getPosition());

            settings.map.view.fitBounds(bounds);

            if (settings.map.view.getZoom() > settings.map.maxZoom) {
                settings.map.view.setZoom(settings.map.maxZoom);
            }
        }

        /**
         * @function onMapClick
         * Fired when the google map is clicked
         */
        function onMapClick() {
            settings.map.infoWindow.close();
        }

        /**
         * @function onCheckZoom
         * Checks the bounds of the map and prevents the user from leaving the country
         */
        function onCheckZoom() {
            if (settings.map.view.getZoom() < settings.map.minZoom) {
                settings.map.view.setZoom(settings.map.minZoom);
            }

            resetListResults();
        }

        /**
         * @function clusterinEnd
         * Fired when the map has finished clustering markers
         */
        function onUpdateResults(resultListSize) {
            settings.resultListSize = resultListSize || settings.resultListChunks;
            calculateCenter();

            // Get IDs of visible (unloaded) markers
            var ids = _.reduce(settings.locations.markers, function (list, marker) {
                var visible = marker.getMap() && settings.map.view.getBounds().contains(marker.getPosition()),
                    loaded = !!marker.data.ProviderName;
                return visible ? list.concat(marker.data.Id) : list;
            }, [], this);

            // No results
            if (!ids.length) {
                $el(settings.el.resultsList).html('').removeClass('is-visible');
                return loadList(allLocations);
            }

            filteredLocations = _.filter(allLocations, function (item) {
                var match = false;
                _.each(ids, function (id) {
                    if (item.Id === id) match = true;
                });
                return match;
            });
            loadList(filteredLocations);

            setLoadingState(false);
        }

        /**
         * @function showLocation
         * @param lat (number)
         * @param lng (number)
         * Focus selected location on map, at provided lat + long coords
         */
        function showLocation(lat, lng, id) {
            settings.map.view.setCenter(new google.maps.LatLng(lat, lng));

            showInfoWindow(id);

            if (settings.map.view.getZoom() < settings.map.maxZoom) {
                settings.map.view.setZoom(settings.map.maxZoom);
            }
        }

        function toggle(e) {
            e.preventDefault();

            settings.toggleState = $wrap.attr('data-state') === 'map' ? 'list' : 'map';
            $wrap.attr('data-state', settings.toggleState);

            $('html,body').animate({scrollTop: $el(settings.el.mapSearchSection).offset().top}, 300);

            // init events
            fitBoundsToMarkers();
            resetListResults();
        }

        function filterState() {
            var value = $el(settings.el.filter).val();
            // Clear the find address
            if (currentAction !== 'address_submit') {
                $el(settings.el.address).val('');
            }

            currentAction = 'filter_state';


            // show all markers and return
            if (value === 'ALL') {
                $.each(settings.locations.markers, function () {
                    this.setMap(settings.map.view);
                    this.setVisible(true);
                });
            } else {
                // show filtered markers
                $.each(settings.locations.markers, function () {
                    if (value !== this.data.State) {
                        this.setMap(null);
                        this.setVisible(false);
                    } else {
                        this.setMap(settings.map.view);
                        this.setVisible(true);
                    }
                });
            }

            onUpdateResults();
            fitBoundsToMarkers();
            currentAction = null;
        }

        function updateFixedMenu() {
            if (!isMobile()) {
                return $el(settings.el.mobileMenu).css({position: "relative", "top": "initial"});
            }

            var currentScroll = $(document).scrollTop(),
                offset = $el(settings.el.mapSearchSection).offset().top + $el(settings.el.mapSearchSection).outerHeight(),
                menuHeight = $el(settings.el.mobileMenu).outerHeight(),
                retailerHeight = $wrap.outerHeight();

            var length;
            if (settings.toggleState === 'map') {
                length = $el(settings.el.map).outerHeight();
            }
            else length = $el(settings.el.results).outerHeight();

            if (currentScroll >= (offset + length - menuHeight)) {
                var top = retailerHeight - menuHeight;
                $el(settings.el.mobileMenu).css({position: "absolute", "top": top});
            } else if (currentScroll >= offset) {
                $el(settings.el.mobileMenu).css({position: "fixed", "top": "0"});
            } else {
                $el(settings.el.mobileMenu).css({position: "absolute", "top": "initial"});
            }
        }

        function resize() {
            var mobile = isMobile();

            updateFixedMenu();

            if (mobile === settings.mobile) {
                return;
            }
            else {
                settings.mobile = mobile;
            }

            onUpdateResults();
        }

        __construct();
        return {
            'setLocations': setLocations
        };
    };

    w.THF = w.THF || {};
    w.THF.Interface = w.THF.Interface || {};
    w.THF.Interface.Map = Map;
    w.THF.Interface.MapReady = false;
})(jQuery, window, document);